import React, {Component} from 'react';
import gsap from "gsap";
import './Scene2.css';
import qs from '../../Resources/quienes-somos.jpeg';
import play from '../../Resources/icons/play.svg'
import CircleText from '../CircleText';
import {FormattedMessage, injectIntl} from "react-intl";
import {ch, cw} from "../../Utilities/utils";
import {withRouter} from "react-router";
import BgGrid from "../BgGrid";
import {logEvent} from "../../Utilities/AmplitudeService";

class Scene2 extends Component {
    constructor(props) {
        super(props);
        this.circle_text = React.createRef();
        this.line = React.createRef();
        this.underlined = React.createRef();
        this.container = React.createRef();
    }

    componentDidMount() {
        let lineTop = ch(this.underlined, this.container);

        gsap.timeline({
            scrollTrigger: {
                trigger: '#s2',
                start: 'top top',
                end: '+=120%',
                scrub: true,
                pin: true,
            }
        }).fromTo(this.line.current, {
            opacity: 0.5,
            width: 0,
            top:  lineTop,
        }, {
            width: cw(this.underlined, this.container),
            top:  lineTop,
            opacity: 1,
            duration: 2,
            repeat: 1,
            repeatDelay: 1,
            yoyo: true,
        }, "2")
        .from(".s2-text-container", {
            opacity: 0,
            top: "-10vh",
            duration: 3,
        }, '0')
        .to(".s2-text", {
            opacity: 0,
            x: "-20vw",
            stagger: .15,
            duration: 3,
        }, "5")
        .from(['#s2bg5H','#s2bg4H','#s2bg3H','#s2bg2H','#s2bg1H','#s2bg0H'],{
            attr:{x1: 0, x2: 0},
            stagger: .2,
            duration: 1,
        }, '0')
        .from(['#s2bg0V','#s2bg1V','#s2bg2V','#s2bg3V','#s2bg4V','#s2bg5V','#s2bg6V','#s2bg7V'],{
            attr:{y1: 1000, y2: 1000},
            stagger: .2,
            duration: 1,
        }, '0')
        .from(['#redCrossH', '#orangeCrossH', '#redCrossV', '#orangeCrossV'], {
            opacity: 0,
            stagger: .3,
            duration: 1,
        }, '1.5')
        .from('#whiteLineV', {
            attr:{y1: -20, y2: 0},
            duration: 2,
        }, '0')
        .from('#whiteCrossV', {
            opacity: 1,
            duration: 2,
            ease: 'Power2.out',
            attr: {y1: -24, y2: 0},
        }, '2')
        .from('#whiteCrossH', {
            opacity: 1,
            duration: 2,
            ease: 'Power2.out',
            attr:{x1: -24, x2: 0},
        },'2')
        .to(['#whiteLineV','#whiteCrossV','#whiteCrossH'], {
            duration: 0.1,
            opacity: 0,
            attr: {y1: '-=35'},
        }, '4.1')
        .to('#whiteCrossV', {
            duration: 3,
            opacity: 1,
            ease: 'Power3.in',
            attr: {y1: 950, y2: 950},
        }, '6')
        .fromTo(".quienes-somos", {
            top: "101vh",
        },{
            opacity: 0.8,
            top: '30vh',
            duration: 3,
        }, '0')
        .from(".video-container", {
            opacity: 0.8,
            scaleX: 0,
            scaleY: 0,
            duration: 1,
        }, "2")
        .to(".video-container", {
            opacity: 0.8,
            top: "-70vh",
            duration: 3,
        }, "5");
    }

    render() {
        return (
            <section id="scene2" className={"s2-container"}>
                <div id='s2' className={"content"}>
                    <img className={"quienes-somos accessibility-img"} src={qs} alt="Quienes Somos"/>
                    <BgGrid id='s2bg' hLines={6}
                        shapes={[
                            {id: 'orangeCross', shape: '+', x:6, y:1, size:6, color:"orange"},
                            {id: 'redCross', shape: '+', x:1, y:4, size:6, color:"red"},
                            {id: 'whiteCross', shape: '+', x:5, y:3, size:12, color:"white", opacityBoost: 4},
                            {id: 'whiteLine', shape: 'V', x:5, y:6, size:20, color:"white", opacityBoost: 4},
                        ]} />
                    <div className={"video-container accessibility-img"}>
                        <div className={"play-circle"}>
                            <div className={"manifest"} ref={this.circle_text}>
                                <CircleText
                                    className={"s2-circle"}
                                    classText={"circle-text"}
                                    title={"• " + this.props.intl.formatMessage({id: 'home_manifesto_button'}) + " •"}
                                    clickEvent={() => {
                                        logEvent('manifesto_play')
                                        this.props.history.push('/manifest/')
                                    }}
                                >
                                </CircleText>
                                <img style={{
                                    width: '25%',
                                    height: '25%',
                                    transform: 'translate(1vmin, 9vmin)'
                                }} src={play} alt={'play'}/>
                            </div>
                        </div>
                    </div>
                    <div ref={this.line} className={"underline purple left accessibility-line"} />
                    <h1 className={'s2-text-container clip-all'} ref={this.container}>
                        <span className={"s2-text"}>
                            <FormattedMessage id={"home_manifesto_txt"}/>
                        </span>
                        <span className={"s2-text"} ref={this.underlined} >
                            <FormattedMessage id={"home_manifesto_txt_2"}/>
                        </span>
                        <span className={"s2-text"}>
                            <FormattedMessage id={"home_manifesto_txt_3"}/>
                        </span>
                        <span className={"s2-text"}>
                            <FormattedMessage id={"home_manifesto_txt_4"}/>
                        </span>
                        <span className={"s2-text"}>
                            <FormattedMessage id={"home_manifesto_txt_5"}/>
                        </span>
                    </h1>
                </div>
            </section>
        )
    }
}

export default injectIntl(withRouter(Scene2));
